/*
  This component specifies options for a ResponsiveBook
  that is rendered in a series context.

  The displayable book title is dependent on user's librarian status,
  and CommunityRating options, description, and WTR button are included.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import GrPropTypes from "../shared/gr_prop_types";
import ResponsiveBook from "../responsive_book";

const SeriesBook = ({ book, isLibrarianView, readOnlyStars }) => {

  const displayableTitle = isLibrarianView ? book.title : book.bookTitleBare;

  const communityRatingOptions = { displayRating: true,
                                   displayAvgRatingText: false,
                                   displayRatingsCount: true,
                                   displayTextReviewsCount: true,
                                   displayPublicationDate: true,
                                   displayEditionsCount: true };

  return(
    <ResponsiveBook book={book}
                    communityRatingOptions={communityRatingOptions}
                    displayableTitle={displayableTitle}
                    includeDescription={true}
                    includeWTRButton={true}
                    readOnlyStars={readOnlyStars} />
  );
};

SeriesBook.propTypes = {
  book: GrPropTypes.book({
    avgRating: PropTypes.number.isRequired,
    ratingsCount: PropTypes.number.isRequired,
    textReviewsCount: PropTypes.number.isRequired,
    toBePublished: PropTypes.bool,
    publicationDate: PropTypes.string.isRequired,
    editions: PropTypes.string.isRequired,
    editionsUrl: PropTypes.string.isRequired,
  }).isRequired,
  isLibrarianView: PropTypes.bool,
  readOnlyStars: PropTypes.bool,
};

SeriesBook.defaultProps = {
  isLibrarianView: false,
  readOnlyStars: false,
};

export default SeriesBook;
